import React from 'react';
import Image from 'next/future/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt } from '@fortawesome/pro-regular-svg-icons/faCommentAlt';
import { faHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { Card } from '@platzi/ui';
import { imageLoader } from 'src/utils/imageOptimizer';
import styles from './BlogpostsCard.module.sass';

export const BlogpostsCard = (props) => {
  return (
    <Card isDark customClass={styles.BlogpostsCard}>
      <a href={props.url}>
        <figure>
          <Image loader={imageLoader} src={props.image} alt={props.title} width={268} height={112} />
        </figure>
        <div className={styles.Body}>
          <h4>{props.title}</h4>
          <div className={styles.Author}>
            <Image
              loader={imageLoader}
              src={props.authorData.avatar}
              alt={props.authorData.public_name}
              width={39}
              height={39}
            />
            <div>
              <p>{props.authorData.public_name}</p>
            </div>
          </div>
        </div>
        <div className={styles.Community}>
          <span>
            <FontAwesomeIcon icon={faHeart} /> {props.likes}
          </span>
          <div>•</div>
          <span>
            <FontAwesomeIcon icon={faCommentAlt} /> {props.comments}
          </span>
        </div>
      </a>
    </Card>
  );
};
